<main class="app-layout">
  <!-- Navbar spans full width at top -->
  <app-navbar></app-navbar>

  <!-- Sidebar fixed below navbar -->
  <app-sidebar></app-sidebar>

  <!-- Main content area with padding for sidebar -->
  <section class="main-content d-flex flex-column" [class.sidebar-expanded]="isSidebarOpen">
    <section class="main-page d-flex flex-column">
      <router-outlet></router-outlet>
      
      <!-- Footer at bottom of content -->
      <!-- <app-footer></app-footer> -->
    </section>
  </section>
</main>
